import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Faq = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">FAQS</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>FAQS</li>
          </ul>
        </div>
      </section>

      <section className="ul-why-join ul-section-spacing">
        <div className="ul-container">
          <div className="row row-cols-md-2 row-cols-1 gy-4 align-items-center">
            <div className="col">
              <div className="ul-why-join-img">
                <img
                  src="/assets/new-img/new/group-of-volunteers-with-working-in-community-char-2025-01-29-08-02-23-utc.jpg"
                  alt="Image"
                />
              </div>
            </div>

            <div className="col">
              <div className="ul-why-join-txt">
                <span className="ul-section-sub-title">Join us</span>
                <h2 className="ul-section-title">
                  Why We Need You Become a Volunteer
                </h2>
                <p className="ul-section-descr">
                  We help companies develop powerful corporate social
                  responsibility, grantmaking, and employee engagement
                  strategies.
                </p>

                <div className="ul-accordion">
                  <div className="ul-single-accordion-item open">
                    <div className="ul-single-accordion-item__header">
                      <div className="left">
                        <h3 className="ul-single-accordion-item__title">
                          Recognition and Fulfillment
                        </h3>
                      </div>
                      <span className="icon"><i className="flaticon-next"></i></span>
                    </div>

                    <div className="ul-single-accordion-item__body">
                      <p>
                        Aonsectetur adipiscing elit Aenean scelerisque augue
                        vitae consequat Juisque eget congue velit in cursus leo
                        sodales the turpis euismod quis sapien euismod quis
                        sapien the. E-learning is suitable for students,
                        professionals, and anyone interested.
                      </p>
                    </div>
                  </div>

                  <div className="ul-single-accordion-item">
                    <div className="ul-single-accordion-item__header">
                      <div className="left">
                        <h3 className="ul-single-accordion-item__title">
                          Why Join Us as a Volunteer?
                        </h3>
                      </div>
                      <span className="icon"><i className="flaticon-next"></i></span>
                    </div>

                    <div className="ul-single-accordion-item__body">
                      <p>
                        Aonsectetur adipiscing elit Aenean scelerisque augue
                        vitae consequat Juisque eget congue velit in cursus leo
                        sodales the turpis euismod quis sapien euismod quis
                        sapien the. E-learning is suitable for students,
                        professionals, and anyone interested.
                      </p>
                    </div>
                  </div>

                  <div className="ul-single-accordion-item">
                    <div className="ul-single-accordion-item__header">
                      <div className="left">
                        <h3 className="ul-single-accordion-item__title">
                          Be Part of a Community
                        </h3>
                      </div>
                      <span className="icon"><i className="flaticon-next"></i></span>
                    </div>

                    <div className="ul-single-accordion-item__body">
                      <p>
                        Aonsectetur adipiscing elit Aenean scelerisque augue
                        vitae consequat Juisque eget congue velit in cursus leo
                        sodales the turpis euismod quis sapien euismod quis
                        sapien the. E-learning is suitable for students,
                        professionals, and anyone interested.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>

      <Footer />
    </>
  );
};

export default Faq;
